"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartConsumer = exports.CartProvider = exports.MenuConsumer = exports.MenuProvider = exports.VariantConsumer = exports.VariantProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var VariantContext = /*#__PURE__*/_react["default"].createContext();

var MenuContext = /*#__PURE__*/_react["default"].createContext({
  schedules: [],
  categories: [],
  items: [],
  modifiers_sets: [],
  modifiers: [],
  disableModifiers: false,
  disableSchedules: false
});

var CartContext = /*#__PURE__*/_react["default"].createContext();

var VariantProvider = VariantContext.Provider;
exports.VariantProvider = VariantProvider;
var VariantConsumer = VariantContext.Consumer;
exports.VariantConsumer = VariantConsumer;
var MenuProvider = MenuContext.Provider;
exports.MenuProvider = MenuProvider;
var MenuConsumer = MenuContext.Consumer;
exports.MenuConsumer = MenuConsumer;
var CartProvider = CartContext.Provider;
exports.CartProvider = CartProvider;
var CartConsumer = CartContext.Consumer;
exports.CartConsumer = CartConsumer;